<div class="ui-g-12">
  <p-panel header="Historique">
    <div class="card timeline ui-fluid">
      <div class="ui-g">
        <div class="ui-g-3">
          <span class="event-time">
            Aujourdhui
          </span>
        </div>
        <div class="ui-g-1"> <i class="pi pi-map-marker" style="color:#3984b8"></i></div>
        <div class="ui-g-8">
          <ul>
            <li>  <span class="event-owner" style="color:#3984b8">50 Moderations terminées</span></li>
            <li>  <span class="event-owner" style="color:#b8b60e">22 Echantillons terminés</span></li>
            <li>  <span class="event-owner" style="color:#b813ad">41 Moderations livrées</span></li>
          </ul>
        </div>
        <div class="ui-g-3">
          <span class="event-time">
            Hier
          </span>
        </div>
        <div class="ui-g-1"> <i class="pi pi-map-marker" style="color:#3984b8"></i></div>
        <div class="ui-g-8">
          <ul>
            <li>  <span class="event-owner" style="color:#3984b8">137 Moderations terminées</span></li>
            <li>  <span class="event-owner" style="color:#b8b60e">144 Echantillons terminés</span></li>
            <li>  <span class="event-owner" style="color:#b813ad">21 Moderations livrées</span></li>
          </ul>
        </div>
        <div class="ui-g-3">
          <span class="event-time">
            Avant-Hier
          </span>
        </div>
        <div class="ui-g-1"> <i class="pi pi-map-marker" style="color:#3984b8"></i></div>
        <div class="ui-g-8">
          <ul>
            <li>  <span class="event-owner" style="color:#3984b8">110 Moderations terminées</span></li>
            <li>  <span class="event-owner" style="color:#b8b60e">100 Echantillons terminés</span></li>
            <li>  <span class="event-owner" style="color:#b813ad">40 Moderations livrées</span></li>
          </ul>
        </div>
        <div class="ui-g-3">
          <span class="event-time">
            Il y a 3 jours
          </span>
        </div>
        <div class="ui-g-1"> <i class="pi pi-map-marker" style="color:#3984b8"></i></div>
        <div class="ui-g-8">
          <ul>
            <li>  <span class="event-owner" style="color:#3984b8">40 Moderations terminées</span></li>
            <li>  <span class="event-owner" style="color:#b8b60e">20 Echantillons terminés</span></li>
            <li>  <span class="event-owner" style="color:#b813ad">20 Moderations livrées</span></li>
          </ul>
        </div>
      </div>
    </div>
  </p-panel>

</div>
